export default __webpack_public_path__ + "static/media/mfactor-bg.f327baee.png";